export default __webpack_public_path__ + "static/media/letalk-community.943f8823.png";